import { formatError, getErrorCode } from '@repo/ui/utils'
import i18n, { type TKey } from '@/lib/i18n'

// The two codes whose backend message is not written for the expert: a
// validation error names the schema path ("[body.data.correctedQty] Too
// big…"), a refused status change names the raw statuses ("archived").
const OWN_TEXTS: Partial<Record<string, TKey>> = {
	validation_error: 'shared:http_errors.validation_error',
	invalid_run_transition: 'po:workflow.transition_refused'
}

// Prefers the backend's human message (already localized and specific, e.g.
// which tables are missing) over the code->i18n mapping, which only knows the
// starter's shared error codes. Falls back to formatError for unknown shapes.
export function poErrorMessage(error: unknown): string {
	const code = getErrorCode(error)
	const own = code === undefined ? undefined : OWN_TEXTS[code]
	if (own) {
		return i18n.t(own)
	}
	const message = (error as { message?: unknown })?.message
	return typeof message === 'string' && message.length > 0
		? message
		: formatError(error)
}
